module.exports = __webpack_public_path__ + "static/img/13.7f9dafd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/13.png
// module id = PUfq
// module chunks = 0